import * as Yup from "yup";
import { required } from "../YupSchema";

export const validationConnectBitget = Yup.object().shape({
  apiKey: required,
  secret: required,
  passphrase: required,
});
